import React from 'react';
import FuzzySearch from 'fuzzy-search';
import { APITypes } from '../../../primary-record-types';
import * as Filtering from '../../shared/Filtering';
import { getIntl } from '../../../utils/intl';

const intl = getIntl('careTeamMemberSearchFilter', {
    placeholder: 'Search Care Team Members',
});

export type CareTeamMemberSearchFilterOwnProps = {
    value: string;
    onChange: (value: string) => void;
    isDisabled?: boolean;
};

export type CareTeamMemberSearchFilterProps = CareTeamMemberSearchFilterOwnProps;

export const applySearchFilter = (
    careTeamMembers: APITypes.medicalProfileService.CareTeamMemberDetails[],
    filterValue: string,
) => {
    if (!filterValue) return careTeamMembers;

    const propList = [
        'firstName',
        'lastName',
        'company',
        'description',
        'phoneNumber',
        'faxNumber',
        'email',
        'url',
        'role',
        'address1',
        'address2',
        'city',
        'state',
        'zipCode',
    ].map((_) => `contactDetails.${_}`);

    const searcher = new FuzzySearch(careTeamMembers, propList, {
        sort: true,
    });

    return searcher.search(filterValue);
};

const CareTeamMemberSearchFilter: React.FC<CareTeamMemberSearchFilterProps> = (props) => {
    return (
        <Filtering.SearchBar
            placeholder={intl('placeholder')}
            value={props.value}
            onChange={props.onChange}
            isDisabled={props.isDisabled}
        />
    );
};

export default React.memo(CareTeamMemberSearchFilter);
